import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const ReactSVGIcon = lazy(() =>
	import(/* webpackChunkName: "reactSVGIcon" */ "@micado-digital/react-svg-icon/ReactSVGIcon")
);
const ReactLink = lazy(() =>
	import(/* webpackChunkName: "reactLink" */ "@micado-digital/react-link/ReactLink")
);

const useStyles = makeStyles(theme => ({
	socialLinks: {
		display: "table",
		[theme.breakpoints.up("md")]: {
			alignItems: "center",
			display: "flex"
		}
	},
	link: {
		alignItems: "center",
		color: theme.palette.secondary.main,
		display: "flex",
		marginBottom: theme.spacing(1),
		transition: theme.transitions.create("color", {
			duration: theme.transitions.duration.complex
		}),
		"&:hover": {
			color: "#FFFFFF"
		},
		"&:last-child": {
			marginBottom: theme.spacing(0)
		},
		"& svg path": {
			transition: theme.transitions.create("fill", {
				duration: theme.transitions.duration.complex
			})
		},
		"&:hover svg path": {
			fill: "#FFFFFF"
		},
		[theme.breakpoints.up("md")]: {
			margin: theme.spacing(0, 2),
			"&:last-child": {
				marginRight: 0
			}
		}
	},
	icon: {
		marginRight: theme.spacing(1)
	},
	label: {
		fontSize: 20
	}
}));

const SocialLinks = ({ socialLinks }) => {
	const css = useStyles();

	return (
		<div className={clsx("mco-footer-01__social-links", css.socialLinks)}>
			{socialLinks?.map(
				(item, i) =>
					item?.type !== "website" && (
						<Link key={i} title={item?.title} type={item?.type} url={item?.url} />
					)
			)}
		</div>
	);
};

const Link = ({ title, type, url }) => {
	const css = useStyles();

	const iconURL = `/img/icons/${type}.svg`;

	return (
		<Suspense fallback={<></>}>
			<ReactLink
				className={clsx("mco-footer-02__social-links-" + type, css.link)}
				to={url}
				target="_blank"
				rel="noreferrer"
			>
				<ReactSVGIcon className={css.icon} color="secondary" size={24} src={iconURL} />
				<Typography className={css.label} component="p" variant="body2">
					{title}
				</Typography>
			</ReactLink>
		</Suspense>
	);
};

SocialLinks.propTypes = {
	socialLinks: PropTypes.array.isRequired
};

export default SocialLinks;
